import React from "react";
import { Route, Routes } from "react-router-dom";
import Dashboard from "../dashboard/Dashboard";
import MyTeam from "../my-team/MyTeam";
import MyContact from "../my-conatact/MyContact";
import MyBlogs from "../Blogs/MyBlogs";
import MyChatavirsity from "../chatavirsity/MyChatavirsity";
import Faq from "../faq/Faq";
import LogoutPage from "../logout-page/LogoutPage";
import BlogDescription from "../Blogs/BlogDescription";
import ChataDescription from "../chatavirsity/ChataDescription";
import ProductivityDescription from "../dashboard/ProductivityDescription";
import IncomeGoal from "../settings/IncomeGoal";
import Company from "../settings/Company";
import Sharing from "../settings/Sharing";
import Contact from "../settings/Contact";
import BillingInformation from "../settings/BillingInformation";
import PaymentMethods from "../settings/PaymentMethods";
import TermsConditions from "../settings/TermsConditions";
import PrivacyPolicy from "../settings/PrivacyPolicy";
import AboutUs from "../settings/AboutUs";
import MyAccount from "../settings/MyAccount";
import NotificaitonPage from "../notificaiton/NotificaitonPage";
import SettingsSidebar from "../settings/SettingsSidebar";
import Scheduled from "../scheduled/Scheduled";

const AppRouter = () => {
  return (
    <>
      <Routes>
        <Route path="/" element={<Dashboard />} />
        <Route path="/my-team" element={<MyTeam />} />
        <Route path="/scheduled" element={<Scheduled />} />
        <Route path="/my-contact" element={<MyContact />} />
        <Route path="/my-blogs" element={<MyBlogs />} />
        <Route path="/blog-description/:slug" element={<BlogDescription />} />
        <Route path="/my-chatavirsity" element={<MyChatavirsity />} />
        <Route
          path="/chatavirsity-description/:slug"
          element={<ChataDescription />}
        />
        <Route path="/settings" element={<SettingsSidebar />} />
        <Route path="/faq" element={<Faq />} />
        <Route path="/logout" element={<LogoutPage />} />
        <Route
          path="/productivity-description"
          element={<ProductivityDescription />}
        />
        <Route path="/notificaiton-page" element={<NotificaitonPage />} />
        {/* SETTING TABS ROUTES */}
        <Route path="/setting/my-account" element={<MyAccount />} />
        <Route path="/setting/income-goals" element={<IncomeGoal />} />
        <Route path="/setting/company" element={<Company />} />
        <Route path="/setting/sharing" element={<Sharing />} />
        <Route path="/setting/contact" element={<Contact />} />
        <Route path="/setting/payment-method" element={<PaymentMethods />} />
        <Route
          path="/setting/billing-information"
          element={<BillingInformation />}
        />
        <Route path="/setting/terms-condition" element={<TermsConditions />} />
        <Route path="/setting/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/setting/about-us" element={<AboutUs />} />`
      </Routes>
    </>
  );
};

export default AppRouter;
